import request from '@/utils/request'

// 分页查询新闻列表
export function pageNews(query) {
  return request({
    url: '/website/news/page',
    method: 'get',
    params: query
  })
}
// 获取新闻详细信息
export function getNewsDetail(id) {
  return request({
    url: `/website/news/${id}`,
    method: 'get',
  })
}